<template>
  <div class="text-start">
    <!--training title-->
    <v-row>
      <v-col>
        <span class="textLight--text font-weight-bold text-start text-h4">
          {{ getLocalisedValue(trainingRegistration.training.title) }}
        </span>
      </v-col>
    </v-row>

    <!--training duration-->
    <v-row
      v-if="trainingRegistration.startDate && trainingRegistration.endDate"
    >
      <v-col class="pt-0">
        <v-icon color="primary"> mdi-calendar-month </v-icon>

        <span class="mx-2 subtitle-2 primary--text">
          {{
            moment(parseInt(trainingRegistration.startDate)).format(
              "DD MMM YYYY"
            )
          }}
          -
          {{
            moment(parseInt(trainingRegistration.endDate)).format("DD MMM YYYY")
          }}
        </span>
      </v-col>
    </v-row>

    <!--training image-->
    <v-row>
      <v-col>
        <v-img
          :src="getImage(trainingRegistration.training.images)"
          lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
          :alt="getLocalisedValue(trainingRegistration.training.title)"
          height="375"
          cover
          style="border-radius: 7px"
        >
        </v-img>
      </v-col>
    </v-row>

    <!--training about tab-->
    <v-row>
      <v-col>
        <v-tabs
          v-model="selectedTab"
          background-color="transparent"
          class="font-weight-medium"
        >
          <v-tab>{{ $t("course.about") }}</v-tab>

          <v-tab>{{ $t("course.instructions") }}</v-tab>

          <v-tab>{{ $t("course.syllabus") }}</v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <!--training about tab items-->
    <v-row class="my-4">
      <v-col>
        <v-tabs-items
          v-model="selectedTab"
          class="transparent textLight--text text-start"
        >
          <v-tab-item>
            <span
              class="body-1"
              v-html="
                getLocalisedValue(trainingRegistration.training.description)
              "
            />
          </v-tab-item>

          <v-tab-item>
            <span
              class="body-1"
              v-html="
                getLocalisedValue(trainingRegistration.training.instructions)
              "
            />
          </v-tab-item>

          <v-tab-item>
            <template
              v-for="(
                trainingModule, trainingModuleIndex
              ) in trainingRegistration.training.trainingModules"
              class="pb-6"
            >
              <v-col :key="trainingModule._id" class="mb-16">
                <v-row>
                  <span class="textLight--text text-h6 font-weight-bold">
                    {{ $t("course.module") }} {{ trainingModuleIndex + 1 }}:
                    {{ getLocalisedValue(trainingModule.title) }}
                  </span>
                </v-row>

                <v-row class="mt-3 mb-4">
                  <span
                    class="primary--text body-1 font-weight-light"
                    style="opacity: 0.5"
                  >
                    {{ getTrainingModuleContentsCountText(trainingModule) }}
                  </span>
                </v-row>

                <v-row class="mb-4">
                  <span class="textLight--text body-1 font-weight-light">
                    {{ getLocalisedValue(trainingModule.description) }}
                  </span>
                </v-row>

                <v-row
                  v-for="trainingModuleContent in trainingModule.trainingModuleContents"
                  :key="trainingModuleContent._id"
                >
                  <v-col class="pa-0 mb-3">
                    <v-card flat class="pa-3 rounded-2">
                      <v-row justify="center" align="center">
                        <!--training module content icon & title-->
                        <v-col>
                          <!--training module content icon-->
                          <v-icon color="textLight">
                            {{
                              getTrainingModuleContentTypeIcon(
                                trainingModuleContent
                              )
                            }}
                          </v-icon>

                          <!--training module content title-->
                          <span class="textLight--text body-2">
                            {{
                              getTrainingModuleContentTitle(
                                trainingModuleContent
                              )
                            }}
                          </span>
                        </v-col>

                        <!--training module content duration-->
                        <v-col
                          cols="12"
                          sm="auto"
                          class="text-end pt-0 pt-sm-3 ps-sm-0"
                        >
                          <span
                            class="
                              textLight--text
                              body-2
                              justify-center
                              align-center
                            "
                            style="opacity: 0.2"
                          >
                            {{
                              `${trainingModuleContent.duration} ${$t(
                                "course.minutes"
                              )}`
                            }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </template>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "CourseAboutAndSyllabus",
  props: {
    trainingRegistration: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
};
</script>

<style lang="scss" scoped />
